import { Injectable } from '@angular/core';
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpContextToken,
	HttpResponse,
} from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';

import { AlertService } from '../../core/services/alert.service';

export const SKIP_NOTIFICATION = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
	constructor(private alertService: AlertService) {}
	public intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(req)
			.pipe(
				// What a change did beyond what was asked (a merged front split up, ...)
				// comes back once, with the response to that change.
				tap((event) => {
					if (event instanceof HttpResponse && Array.isArray(event.body?.notices)) {
						this.alertService.handleNotices(event.body.notices);
					}
				}),
				catchError((err) => {
					if (!req.context.get(SKIP_NOTIFICATION)) {
						this.alertService.handleError(err);
					}
					return throwError(() => err)
				})
			)
	}
}
